export const countryOptions = [
  { value: 'Brazil', label: 'Brazil' },
	{ value: 'South Africa', label: 'South Africa' },
	{ value: 'Albania', label: 'Albania' },
	{ value: 'Germany', label: 'Germany' },
	{ value: 'Andorra', label: 'Andorra' },
	{ value: 'Angola', label: 'Angola' },
	{ value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
	{ value: 'Saudi Arabia', label: 'Saudi Arabia' },
	{ value: 'Algeria', label: 'Algeria' },
	{ value: 'Argentina', label: 'Argentina' },
	{ value: 'Armenia', label: 'Armenia' },
	{ value: 'Australia', label: 'Australia' },
	{ value: 'Austria', label: 'Austria' },
	{ value: 'Azerbaijan', label: 'Azerbaijan' },
	{ value: 'Bahamas', label: 'Bahamas' },
	{ value: 'Bangladesh', label: 'Bangladesh' },
	{ value: 'Barbados', label: 'Barbados' },
	{ value: 'Bahrain', label: 'Bahrain' },
	{ value: 'Belarus', label: 'Belarus' },
	{ value: 'Belgium', label: 'Belgium' },
	{ value: 'Belize', label: 'Belize' },
	{ value: 'Benin', label: 'Benin' },
	{ value: 'Bolivia', label: 'Bolivia' },
	{ value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
	{ value: 'Botswana', label: 'Botswana' },
	{ value: 'Brunei', label: 'Brunei' },
	{ value: 'Bulgaria', label: 'Bulgaria' },
	{ value: 'Burkina Faso', label: 'Burkina Faso' },
	{ value: 'Burundi', label: 'Burundi' },
	{ value: 'Bhutan', label: 'Bhutan' },
	{ value: 'Cape Verde', label: 'Cape Verde' },
	{ value: 'Cameroon', label: 'Cameroon' },
	{ value: 'Cambodia', label: 'Cambodia' },
	{ value: 'Canada', label: 'Canada' },
	{ value: 'Qatar', label: 'Qatar' },
	{ value: 'Kazakhstan', label: 'Kazakhstan' },
	{ value: 'Chad', label: 'Chad' },
	{ value: 'Chile', label: 'Chile' },
	{ value: 'China', label: 'China' },
	{ value: 'Cyprus', label: 'Cyprus' },
	{ value: 'Colombia', label: 'Colombia' },
	{ value: 'Comoros', label: 'Comoros' },
	{ value: 'Democratic Republic of the Congo', label: 'Democratic Republic of the Congo' },
	{ value: 'North Korea', label: 'North Korea' },
	{ value: 'South Korea', label: 'South Korea' },
	{ value: 'Ivory Coast', label: 'Ivory Coast' },
	{ value: 'Costa Rica', label: 'Costa Rica' },
	{ value: 'Croatia', label: 'Croatia' },
	{ value: 'Cuba', label: 'Cuba' },
	{ value: 'Denmark', label: 'Denmark' },
	{ value: 'Djibouti', label: 'Djibouti' },
	{ value: 'Dominica', label: 'Dominica' },
	{ value: 'Egypt', label: 'Egypt' },
	{ value: 'El Salvador', label: 'El Salvador' },
	{ value: 'United Arab Emirates', label: 'United Arab Emirates' },
	{ value: 'Ecuador', label: 'Ecuador' },
	{ value: 'Eritrea', label: 'Eritrea' },
	{ value: 'Slovakia', label: 'Slovakia' },
	{ value: 'Slovenia', label: 'Slovenia' },
	{ value: 'Spain', label: 'Spain' },
	{ value: 'Eswatini', label: 'Eswatini' },
	{ value: 'United States', label: 'United States' },
	{ value: 'Estonia', label: 'Estonia' },
	{ value: 'Ethiopia', label: 'Ethiopia' },
	{ value: 'Finland', label: 'Finland' },
	{ value: 'France', label: 'France' },
	{ value: 'Gabon', label: 'Gabon' },
	{ value: 'Gambia', label: 'Gambia' },
	{ value: 'Ghana', label: 'Ghana' },
	{ value: 'Greece', label: 'Greece' },
	{ value: 'Guatemala', label: 'Guatemala' },
	{ value: 'Guyana', label: 'Guyana' },
	{ value: 'Haiti', label: 'Haiti' },
	{ value: 'Honduras', label: 'Honduras' },
	{ value: 'Hungary', label: 'Hungary' },
	{ value: 'India', label: 'India' },
	{ value: 'Indonesia', label: 'Indonesia' },
	{ value: 'Iran', label: 'Iran' },
	{ value: 'Iraq', label: 'Iraq' },
	{ value: 'Ireland', label: 'Ireland' },
	{ value: 'Israel', label: 'Israel' },
	{ value: 'Italy', label: 'Italy' },
	{ value: 'Jamaica', label: 'Jamaica' },
	{ value: 'Japan', label: 'Japan' },
	{ value: 'Jordan', label: 'Jordan' },
	{ value: 'Kuwait', label: 'Kuwait' },
	{ value: 'Lebanon', label: 'Lebanon' },
	{ value: 'Mexico', label: 'Mexico' },
	{ value: 'Mozambique', label: 'Mozambique' },
	{ value: 'Netherlands', label: 'Netherlands' },
	{ value: 'New Zealand', label: 'New Zealand' },
	{ value: 'Norway', label: 'Norway' },
	{ value: 'Pakistan', label: 'Pakistan' },
	{ value: 'Portugal', label: 'Portugal' },
	{ value: 'Russia', label: 'Russia' },
	{ value: 'Saudi Arabia', label: 'Saudi Arabia' },
	{ value: 'Sweden', label: 'Sweden' },
	{ value: 'Switzerland', label: 'Switzerland' },
	{ value: 'Turkey', label: 'Turkey' },
	{ value: 'Ukraine', label: 'Ukraine' },
	{ value: 'United Kingdom', label: 'United Kingdom' },
	{ value: 'Vatican', label: 'Vatican' },
	{ value: 'Venezuela', label: 'Venezuela' },
	{ value: 'Vietnam', label: 'Vietnam' },
];
